import { useEffect, useState } from 'react';

import { DescriptionOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { IFilePreviewProps } from 'src/features/patient_asset';

const FilePreview: React.FC<IFilePreviewProps> = ({
	file,
	type,
	dicomConversion,
}) => {
	const [previewUrl, setPreviewUrl] = useState<string | null>(null);

	useEffect(() => {
		if (type !== 'image') {
			setPreviewUrl(null);
			return;
		}

		const url = URL.createObjectURL(file);
		setPreviewUrl(url);

		return () => {
			URL.revokeObjectURL(url);
		};
	}, [file, type]);

	if (type === 'image') {
		return (
			<Box
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					position: 'relative',
				}}
			>
				{previewUrl && (
					<img
						src={previewUrl}
						alt='preview'
						style={{
							border: 1,
							borderStyle: 'dashed',
							marginBottom: 'auto',
							marginTop: 'auto',
							width: '100%',
							height: dicomConversion
								? 'calc(100% - 36px)'
								: '100%',
							objectFit: 'contain',
							borderRadius: '4px',
							pointerEvents: 'none',
							userSelect: 'none',
							backgroundColor: '#fafafa',
						}}
					/>
				)}
				{dicomConversion && (
					<Typography
						variant='caption'
						sx={{
							px: 1,
							py: 0.75,
							textAlign: 'center',
							color: 'text.secondary',
							wordBreak: 'break-word',
						}}
					>
						Converted from {dicomConversion.sourceName} ·{' '}
						{dicomConversion.width}×{dicomConversion.height} px
					</Typography>
				)}
			</Box>
		);
	}

	if (type === 'file') {
		return (
			<Box
				sx={{
					border: 1,
					borderStyle: 'dashed',
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<DescriptionOutlined sx={{ width: 100, height: 100 }} />
				<Typography
					sx={{
						width: '100%',
						fontSize: { xs: '14px', sm: '18px' },
						lineHeight: '31.5px',
						textAlign: 'center',
						wordWrap: 'break-word',
					}}
				>
					{file.name}
				</Typography>
			</Box>
		);
	}

	return null;
};

export default FilePreview;
